import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Add, Search, FilterList } from '@mui/icons-material';
import { brand } from '../../theme/colors';

/**
 * Empty State Component for Projects Page
 * Shows when there are no projects or no search results
 */
const ProjectsEmptyState = ({ type = 'no_projects', onCreateProject, onClearFilters }) => {
  const emptyStates = {
    no_projects: {
      icon: '📁',
      title: 'No projects yet',
      description: 'Get started by creating your first construction project. Track progress, manage milestones, and collaborate with contractors.',
      action: (
        <Button
          variant="contained"
          size="large"
          startIcon={<Add />}
          onClick={onCreateProject}
          sx={{
            mt: 3,
            px: 4,
            py: 1.5,
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2,
            background: brand.gradient,
            '&:hover': {
              background: brand.gradientHover
            }
          }}
        >
          Create Your First Project
        </Button>
      )
    },
    no_results: {
      icon: '🔍',
      title: 'No projects found',
      description: 'We couldn\'t find any projects matching your search criteria. Try adjusting your filters or search terms.',
      action: (
        <Button
          variant="outlined"
          size="large"
          startIcon={<FilterList />}
          onClick={onClearFilters}
          sx={{
            mt: 3,
            px: 4,
            py: 1.5,
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2
          }}
        >
          Clear All Filters
        </Button>
      )
    },
    loading_error: {
      icon: '⚠️',
      title: 'Unable to load projects',
      description: 'There was an error loading your projects. Please try refreshing the page.',
      action: (
        <Button
          variant="contained"
          size="large"
          onClick={() => window.location.reload()}
          sx={{
            mt: 3,
            px: 4,
            py: 1.5,
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 2
          }}
        >
          Refresh Page
        </Button>
      )
    }
  };

  const state = emptyStates[type] || emptyStates.no_projects;

  return (
    <Paper
      sx={{
        p: 8,
        textAlign: 'center',
        borderRadius: 3,
        border: '2px dashed #e0e0e0',
        backgroundColor: '#fafafa'
      }}
    >
      <Typography
        sx={{
          fontSize: '80px',
          mb: 2,
          opacity: 0.8
        }}
      >
        {state.icon}
      </Typography>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: '#1a1a1a',
          mb: 1
        }}
      >
        {state.title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: '#666',
          maxWidth: 500,
          mx: 'auto',
          mb: 2
        }}
      >
        {state.description}
      </Typography>
      {state.action}
    </Paper>
  );
};

export default ProjectsEmptyState;
